import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

export type IconSize = 'smaller' | 'small' | 'general' | 'big';

@Component({
  selector: 'ac-icon',
  templateUrl: 'icon.component.html',
  styleUrls: ['./icon.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [NgClass],
})
export class IconComponent {
  /** Name of the icon to be showed */
  @Input({ required: true }) public name!: string;
  /** Defaults size icon */
  @Input() public size: IconSize = 'general';
  /** Defines the extra icon classes */
  @Input() public color?: 'default' | 'warning' | 'white' | 'primary' = 'default';
}
